class HeroImageAnimate extends window.BAO.CustomElement {
    constructor () {
      super()
      this.setupListeners()
    }

    setupListeners() {
      const imageList = this.querySelectorAll('.sec-HeroSlide_Image');

      const speed = parseInt(this.getAttribute('data-animateImageSpeed'));

      let imageId = 0
      setInterval(function() {
        if (imageId < imageList.length){
          imageList.forEach(e => {
            e.classList.remove('active')
          });
          imageList[imageId].classList.add('active')
          imageId ++
        } else  {
          imageId = 0
          imageList.forEach(e => {
            e.classList.remove('active')
          });
          imageList[imageId].classList.add('active')
          imageId ++
        }
      }, speed);
    }
}

customElements.define('hero-animate', HeroImageAnimate)